import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react";
import { Logo } from "@/components/marketing/Navbar";
import { NotifyMe } from "@/components/app/NotifyMe";

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-white">
      <div className="mx-auto max-w-7xl px-5 py-12 sm:px-8">
        <div className="grid gap-8 sm:grid-cols-2 md:grid-cols-5">
          <div className="md:col-span-1">
            <Logo />
            <p className="mt-3 max-w-xs text-sm text-slate-500">
              AI Value Management for measuring the cost, savings, and return of AI adoption.
            </p>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-slate-400">Product</p>
            <ul className="mt-3 space-y-2 text-sm text-slate-600">
              <li><Link to="/" className="hover:text-slate-900">Overview</Link></li>
              <li><Link to="/integrations" className="hover:text-slate-900">Integrations &amp; API</Link></li>
              <li><Link to="/pricing" className="hover:text-slate-900">Pricing</Link></li>
              <li><Link to="/resources" className="hover:text-slate-900">Resources</Link></li>
              <li><Link to="/demo" className="hover:text-slate-900">Sample dashboard</Link></li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-slate-400">Free Tools &amp; Guides</p>
            <ul className="mt-3 space-y-2 text-sm text-slate-600">
              <li><Link to="/resources/tools/ai-roi-calculator" className="hover:text-slate-900" data-testid="footer-roi-calculator">AI ROI Calculator</Link></li>
              <li><Link to="/resources/tools/ai-platform-pricing-index-and-directory" className="hover:text-slate-900" data-testid="footer-pricing-index">AI Pricing Index</Link></li>
              <li><Link to="/resources/ai-roi/what-is-ai-value-management" className="hover:text-slate-900" data-testid="footer-what-is-avm">What Is AI Value Management?</Link></li>
              <li><Link to="/resources/ai-roi/how-netlift-calculates-ai-value" className="hover:text-slate-900" data-testid="footer-how-calculated">How NetLift Calculates AI Value</Link></li>
              <li><Link to="/resources/ai-roi/netlift-vs-spreadsheets-for-ai-roi" className="hover:text-slate-900" data-testid="footer-vs-spreadsheets">NetLift vs Spreadsheets</Link></li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-slate-400">Company</p>
            <ul className="mt-3 space-y-2 text-sm text-slate-600">
              <li><Link to="/about" className="hover:text-slate-900" data-testid="footer-about">About</Link></li>
              <li><Link to="/press" className="hover:text-slate-900" data-testid="footer-press">Press &amp; Media</Link></li>
              <li><Link to="/affiliates" className="hover:text-slate-900" data-testid="footer-affiliates">Affiliate Program</Link></li>
              <li><Link to="/contact" className="hover:text-slate-900">Contact</Link></li>
              <li><a href="mailto:support@netlift.app" className="hover:text-slate-900">support@netlift.app</a></li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-slate-400">Legal</p>
            <ul className="mt-3 space-y-2 text-sm text-slate-600">
              <li><Link to="/privacy" className="hover:text-slate-900">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-slate-900">Terms of Use</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-10 flex flex-col items-start justify-between gap-4 border-t border-slate-100 pt-6 sm:flex-row sm:items-center">
          <div>
            <p className="text-sm font-medium text-slate-700">Stay in the loop</p>
            <p className="mt-0.5 text-xs text-slate-400">Get NetLift releases, feature updates, and product announcements.</p>
          </div>
          <NotifyMe topic="product_updates" label="Notify me about product updates" testid="footer-notify" />
        </div>
        <div className="mt-6 flex flex-col items-start justify-between gap-3 border-t border-slate-100 pt-6 text-xs text-slate-400 sm:flex-row sm:items-center">
          <div className="flex items-center gap-3">
            <p>© {new Date().getFullYear()} NetLift.app · AI Value Management</p>
            <a
              href="https://www.linkedin.com/company/netliftapp"
              target="_blank"
              rel="noreferrer"
              aria-label="NetLift on LinkedIn"
              className="text-slate-400 transition-colors hover:text-editorial"
              data-testid="footer-linkedin"
            >
              <Linkedin className="h-4 w-4" />
            </a>
          </div>
          <p>Results depend on the data, assumptions, and evidence provided. NetLift is not accounting, tax, legal, or HR advice.</p>
        </div>
      </div>
    </footer>
  );
}
